/**
 * StrategyLab's pages, over the hub's API.
 *
 * The hub implements the lab's contract at the same paths (hub-api's lab/
 * routers), so the lab's own transport-agnostic service works unchanged —
 * this is only the transport: same origin, cookie attached, errors surfaced
 * the way the lab's pages expect.
 */
import { createDataService } from "@strat/ui";
import type { IDataService } from "@strat/ui";

export const labService: IDataService = createDataService(async (path, init) => {
  const res = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string; errors?: string[] };
    throw new Error(body.error ?? body.errors?.join(", ") ?? `Request failed: ${res.status}`);
  }
  if (res.status === 204) return undefined;
  return res.json() as Promise<unknown>;
});
